window.ParsleyConfig = {
    errorsContainer: function (Field) {
        var $errorWrapper = $(Field.element).closest('[data-parsley-error-wrapper]');
        if ($errorWrapper.length) {
            return $errorWrapper;
        }
    }
}
